import './App.css';
import Display from './components/Display/Display';

function App() {
  return (
    <div className="App">
      <Display />
    </div>
  );
}

export default App;
